/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ExpandFleetEventShipFromModelBody,
  FleetEventShip,
  FleetEventShipCreateInput,
  FleetEventShipUpdateInput,
  SchemaValidationErrorResponse,
  SortFleetEventShipsBody,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create event ship
 */
export const createFleetEventShip = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetEventSlug: MaybeRefOrGetter<string>,
    fleetEventTeamId: MaybeRefOrGetter<string>,
    fleetEventShipCreateInput: MaybeRefOrGetter<FleetEventShipCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetEventSlug = toValue(fleetEventSlug);
fleetEventTeamId = toValue(fleetEventTeamId);
fleetEventShipCreateInput = toValue(fleetEventShipCreateInput);

      return axiosClient<FleetEventShip>(
      {url: `/fleets/${fleetSlug}/events/${fleetEventSlug}/teams/${fleetEventTeamId}/ships`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventShipCreateInput, signal
    },
      );
    }




export const getCreateFleetEventShipMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetEventShip>>, TError,{fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;data: FleetEventShipCreateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetEventShip>>, TError,{fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;data: FleetEventShipCreateInput}, TContext> => {

const mutationKey = ['createFleetEventShip'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetEventShip>>, {fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;data: FleetEventShipCreateInput}> = (props) => {
          const {fleetSlug,fleetEventSlug,fleetEventTeamId,data} = props ?? {};

          return  createFleetEventShip(fleetSlug,fleetEventSlug,fleetEventTeamId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetEventShipMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetEventShip>>>
    export type CreateFleetEventShipMutationBody = FleetEventShipCreateInput
    export type CreateFleetEventShipMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Create event ship
 */
export const useCreateFleetEventShip = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetEventShip>>, TError,{fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;data: FleetEventShipCreateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetEventShip>>,
        TError,
        {fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;data: FleetEventShipCreateInput},
        TContext
      > => {
      return useMutation(getCreateFleetEventShipMutationOptions(options), queryClient);
    }
    /**
 * @summary Sort event ships
 */
export const sortFleetEventShips = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetEventSlug: MaybeRefOrGetter<string>,
    fleetEventTeamId: MaybeRefOrGetter<string>,
    sortFleetEventShipsBody: MaybeRefOrGetter<SortFleetEventShipsBody>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetEventSlug = toValue(fleetEventSlug);
fleetEventTeamId = toValue(fleetEventTeamId);
sortFleetEventShipsBody = toValue(sortFleetEventShipsBody);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/events/${fleetEventSlug}/teams/${fleetEventTeamId}/ships/sort`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: sortFleetEventShipsBody, signal
    },
      );
    }




export const getSortFleetEventShipsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sortFleetEventShips>>, TError,{fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;data: SortFleetEventShipsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sortFleetEventShips>>, TError,{fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;data: SortFleetEventShipsBody}, TContext> => {

const mutationKey = ['sortFleetEventShips'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sortFleetEventShips>>, {fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;data: SortFleetEventShipsBody}> = (props) => {
          const {fleetSlug,fleetEventSlug,fleetEventTeamId,data} = props ?? {};

          return  sortFleetEventShips(fleetSlug,fleetEventSlug,fleetEventTeamId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SortFleetEventShipsMutationResult = NonNullable<Awaited<ReturnType<typeof sortFleetEventShips>>>
    export type SortFleetEventShipsMutationBody = SortFleetEventShipsBody
    export type SortFleetEventShipsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Sort event ships
 */
export const useSortFleetEventShips = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sortFleetEventShips>>, TError,{fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;data: SortFleetEventShipsBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sortFleetEventShips>>,
        TError,
        {fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;data: SortFleetEventShipsBody},
        TContext
      > => {
      return useMutation(getSortFleetEventShipsMutationOptions(options), queryClient);
    }
    /**
 * @summary Update event ship
 */
export const updateFleetEventShip = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetEventSlug: MaybeRefOrGetter<string>,
    fleetEventTeamId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    fleetEventShipUpdateInput: MaybeRefOrGetter<FleetEventShipUpdateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetEventSlug = toValue(fleetEventSlug);
fleetEventTeamId = toValue(fleetEventTeamId);
id = toValue(id);
fleetEventShipUpdateInput = toValue(fleetEventShipUpdateInput);

      return axiosClient<FleetEventShip>(
      {url: `/fleets/${fleetSlug}/events/${fleetEventSlug}/teams/${fleetEventTeamId}/ships/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventShipUpdateInput, signal
    },
      );
    }




export const getUpdateFleetEventShipMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventShip>>, TError,{fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;id: string;data: FleetEventShipUpdateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventShip>>, TError,{fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;id: string;data: FleetEventShipUpdateInput}, TContext> => {

const mutationKey = ['updateFleetEventShip'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetEventShip>>, {fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;id: string;data: FleetEventShipUpdateInput}> = (props) => {
          const {fleetSlug,fleetEventSlug,fleetEventTeamId,id,data} = props ?? {};

          return  updateFleetEventShip(fleetSlug,fleetEventSlug,fleetEventTeamId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetEventShipMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetEventShip>>>
    export type UpdateFleetEventShipMutationBody = FleetEventShipUpdateInput
    export type UpdateFleetEventShipMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update event ship
 */
export const useUpdateFleetEventShip = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventShip>>, TError,{fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;id: string;data: FleetEventShipUpdateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetEventShip>>,
        TError,
        {fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;id: string;data: FleetEventShipUpdateInput},
        TContext
      > => {
      return useMutation(getUpdateFleetEventShipMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy event ship
 */
export const destroyFleetEventShip = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetEventSlug: MaybeRefOrGetter<string>,
    fleetEventTeamId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetEventSlug = toValue(fleetEventSlug);
fleetEventTeamId = toValue(fleetEventTeamId);
id = toValue(id);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/events/${fleetEventSlug}/teams/${fleetEventTeamId}/ships/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetEventShipMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventShip>>, TError,{fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventShip>>, TError,{fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;id: string}, TContext> => {

const mutationKey = ['destroyFleetEventShip'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetEventShip>>, {fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;id: string}> = (props) => {
          const {fleetSlug,fleetEventSlug,fleetEventTeamId,id} = props ?? {};

          return  destroyFleetEventShip(fleetSlug,fleetEventSlug,fleetEventTeamId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetEventShipMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetEventShip>>>

    export type DestroyFleetEventShipMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Destroy event ship
 */
export const useDestroyFleetEventShip = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventShip>>, TError,{fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetEventShip>>,
        TError,
        {fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;id: string},
        TContext
      > => {
      return useMutation(getDestroyFleetEventShipMutationOptions(options), queryClient);
    }
    /**
 * @summary Expand ship slots from model positions
 */
export const expandFleetEventShipFromModel = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetEventSlug: MaybeRefOrGetter<string>,
    fleetEventTeamId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    expandFleetEventShipFromModelBody: MaybeRefOrGetter<ExpandFleetEventShipFromModelBody>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetEventSlug = toValue(fleetEventSlug);
fleetEventTeamId = toValue(fleetEventTeamId);
id = toValue(id);
expandFleetEventShipFromModelBody = toValue(expandFleetEventShipFromModelBody);

      return axiosClient<FleetEventShip>(
      {url: `/fleets/${fleetSlug}/events/${fleetEventSlug}/teams/${fleetEventTeamId}/ships/${id}/expand-from-model`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: expandFleetEventShipFromModelBody, signal
    },
      );
    }




export const getExpandFleetEventShipFromModelMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof expandFleetEventShipFromModel>>, TError,{fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;id: string;data: ExpandFleetEventShipFromModelBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof expandFleetEventShipFromModel>>, TError,{fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;id: string;data: ExpandFleetEventShipFromModelBody}, TContext> => {

const mutationKey = ['expandFleetEventShipFromModel'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof expandFleetEventShipFromModel>>, {fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;id: string;data: ExpandFleetEventShipFromModelBody}> = (props) => {
          const {fleetSlug,fleetEventSlug,fleetEventTeamId,id,data} = props ?? {};

          return  expandFleetEventShipFromModel(fleetSlug,fleetEventSlug,fleetEventTeamId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExpandFleetEventShipFromModelMutationResult = NonNullable<Awaited<ReturnType<typeof expandFleetEventShipFromModel>>>
    export type ExpandFleetEventShipFromModelMutationBody = ExpandFleetEventShipFromModelBody
    export type ExpandFleetEventShipFromModelMutationError = ErrorType<SchemaValidationErrorResponse | StandardError | void>

    /**
 * @summary Expand ship slots from model positions
 */
export const useExpandFleetEventShipFromModel = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof expandFleetEventShipFromModel>>, TError,{fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;id: string;data: ExpandFleetEventShipFromModelBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof expandFleetEventShipFromModel>>,
        TError,
        {fleetSlug: string;fleetEventSlug: string;fleetEventTeamId: string;id: string;data: ExpandFleetEventShipFromModelBody},
        TContext
      > => {
      return useMutation(getExpandFleetEventShipFromModelMutationOptions(options), queryClient);
    }
